import DespesaNova from './DespesaNova';

export default DespesaNova;